<template>
    <div class="hero">
        <div class="hero__inner">
          <swiper v-bind="{
                  navigation: {
                      prevEl: btnPrev,
                      nextEl: btnNext,
                  },
                  loop : true,
              }"
              :modules="modules"
          >
              <swiper-slide class="hero__slide" v-for="(item, i) in params.items" :key="i" :style="item.bg" style="height: auto;
      background-size: cover;
      background-position: center; padding-top: 70px">
                  <div class="container">
                      <div class="row hero__row between">
                          <div class="col d6 md-5 sm-12 hero__col hero__col-left">
                              <div class="hero__col-inner">
                                  <div class="hero__title">{{ item.title }}</div>
                                  <div class="hero__content" v-html="item.content"></div>
                                  <div class="hero__actions" v-if="item.link&&item.buttonTitle">
                                      <ABtn :href="item.link" :label="item.buttonTitle" class="hero__btn primary" />
                                  </div>
                              </div>
                          </div>
                          <div :class="['col d6 md-7 sm-12 hero__col hero__col-right', item.position]"
                               :style="item.image_only_mobile&&InnertW<767?'background-image:url(\''+item.image+'\');':''">
                              <div class="hero__col-inner">
                                  <div class="hero__media" v-if="!item.image_only_mobile">
                                      <img :src="item.image" alt="1">
                                  </div>
                                  <div :class="['hero__card', item.card_position]" v-if="item.person">
                                      <div class="hero__card-top">{{ item.person.name }}</div>
                                      <div class="hero__card-title">{{ item.person.spec }}</div>
                                      <div class="hero__card-desc">{{params.messages.lastWorktitle}}</div>
                                      <div class="hero__card-img">
                                          <img :src="item.person.image" alt="2">
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </swiper-slide>
          </swiper>

            <div class="hero__nav" v-if="params.items.length>1">
                <div class="container">
                    <button class="swiper-button-prev" ref="btnPrev" aria-label="previous slide">
                        <svg class="icon" width="26" height="20" viewBox="0 0 26 20" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
                            <path d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
                            <path d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
                            <path d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
                        </svg>
                    </button>
                    <button class="swiper-button-next" ref="btnNext" aria-label="next slide">
                        <svg class="icon" width="26" height="20" viewBox="0 0 26 20" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.28201 18.4849L1.50383 10.7068C1.11331 10.3162 1.11331 9.68308 1.50383 9.29256C1.89436 8.90203 2.52752 8.90203 2.91804 9.29256L10.6962 17.0707C11.0867 17.4613 11.0867 18.0944 10.6962 18.4849C10.3057 18.8755 9.67253 18.8755 9.28201 18.4849Z"/>
                            <path d="M1.50383 10.7065C1.11331 10.3159 1.11331 9.68278 1.50383 9.29225C1.89435 8.90173 2.52752 8.90173 2.91804 9.29225C3.30857 9.68278 3.30857 10.3159 2.91804 10.7065C2.52752 11.097 1.89436 11.097 1.50383 10.7065Z"/>
                            <path d="M3.21094 8.80811L24.2109 8.80811C24.7632 8.80811 25.2109 9.25582 25.2109 9.80811C25.2109 10.3604 24.7632 10.8081 24.2109 10.8081L3.21094 10.8081C2.65865 10.8081 2.21094 10.3604 2.21094 9.80811C2.21094 9.25582 2.65865 8.80811 3.21094 8.80811Z"/>
                            <path d="M1.50676 9.29324L9.28493 1.51506C9.67545 1.12454 10.3086 1.12454 10.6991 1.51506C11.0897 1.90559 11.0897 2.53875 10.6991 2.92927L2.92097 10.7074C2.53044 11.098 1.89728 11.098 1.50676 10.7074C1.11623 10.3169 1.11623 9.68376 1.50676 9.29324Z"/>
                        </svg>
                    </button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import { ABtn } from './ui'
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from "swiper";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default {
    name: 'Hero',
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        Swiper,
        SwiperSlide,
        ABtn,
    },
    setup: (props, ctx) => {

        const btnNext = ref(null)
        const btnPrev = ref(null)
        const InnertW = window.innerWidth;
        return {
            modules: [Navigation, Pagination],
            btnPrev,
            InnertW,
            btnNext,
        }
    },
}
</script>

<style lang="scss" scoped>
    .hero {
        &__inner {
            position: relative;
        }
        &__slide {

            padding-top: 70px;
            background: #EFEFF1;
            height: auto;
            max-height: 98vh;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;

            @include tablet {
                max-height: 460px;
            }
            @include mobile {
                padding-top: 0;
                max-height: initial;
                background: transparent !important;
            }
            .container {
                height: 100%;
                @include mobile {
                    padding: 0;
                }

            }
        }
        &__row {
            height: 100%;
            @include mobile {
                flex-wrap: wrap;
                flex-direction: column-reverse;
                justify-content: flex-start;
                height: auto;
                margin: 0;
            }
        }
        &__col {
            height: 100%;
            &-inner {
                position: relative;
                height: 100%;
            }
            @include mobile {
                padding: 0 15px;
                width: 100%;
            }
            &-left {
                padding-top: 14%;
                height: 100%;

                @include tablet {
                    padding-top: 110px;
                }
                @include mobile {
                    padding-top: 17px;
                    background: #fff;
                }
            }
            &-right {
                position: relative;
                height: 100%;
                background-size: cover;
                @include desktop {
                  background-image: none!important;
                }

                @include mobile {
                    padding-top: 50px;
                    background-color: #EFEFF1;
                    height: 405px;

                }
                .hero__col-inner {
                    @include mobile {
                        margin: 0 -15px;
                    }
                }
                &.center {
                    .hero__col-inner {
                        @include mobile {
                            margin: 0;
                        }
                    }
                    .hero__media {
                        @include mobile {

                        }
                    }
                    img {
                        @include mobile {
                            object-fit: initial;
                            width: auto;
                            height: auto;
                        }
                    }
                }
            }
        }
        &__title {
            font-family: var(--font-secondary);
            font-weight: 500;
            font-size: 74px;
            line-height: 74px;

            @include tablet {
                font-size: 32px;
                line-height: 42px;
            }
        }
        &__content {
            font-family: var(--font-secondary);
            font-weight: 500;
            font-size: 18px;
            line-height: 28px;
            margin-top: 48px;
            max-width: 560px;

            @include tablet {
                font-family: var(--font-primary);
                margin-top: 12px;
                font-size: 13px;
                line-height: 20px;
                font-weight: 400;

                .m-hide {
                    display: none;
                }
            }
        }
        &__actions {
            margin-top: 36px;
          margin-bottom: 50px;
            @include tablet {
                margin-top: 16px;
            }
        }
        &__btn {
            @include mobile {
                width: 100%;
            }
        }
        &__media {
            line-height: 1px;
            height: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            @include mobile {
                justify-content: center;
            }

            img {
                max-height: 100%;

                @include mobile {
                    object-fit: contain;
                    width: 100%;
                    height: 100%;
                }
            }
        }
        &__card {
            width: 220px;
            position: absolute;
            padding: 24px;
            background: #fff;
            border-radius: var(--br-1);
            z-index: 1;
            box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
            left: 0;
            bottom: 10%;

            @include tablet {
                width: 150px;
                padding: 16px 14px;
            }
            @include mobile {
                left: 15px;
                bottom: 20px;
            }

            &.right {
                left: auto;
                right: 0;
                @include mobile {
                    right: 15px;
                }
            }
            &-top {
                font-size: 12px;
                line-height: 16px;
                color: var(--c-primary-200);
                @include tablet {
                    font-size: 9px;
                    line-height: 12px;
                }
            }
            &-title {
                margin-top: 2px;
                font-weight: 600;
                font-size: 16px;
                line-height: 24px;
                color: var(--c-gray-100);

                @include tablet {
                    font-size: 12px;
                    line-height: 18px;
                }
            }
            &-desc {
                font-size: 12px;
                line-height: 16px;
                color: var(--c-gray-500);
                margin-top: 2px;

                @include tablet {
                    font-size: 8px;
                    line-height: 11px;
                }
            }
            &-img {
                margin-top: 10px;
                line-height: 1px;

                @include tablet {
                    margin-top: 6px;
                }
            }
        }

        &__nav {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
            width: 100%;
            pointer-events: none;
            height: 100%;
            padding-top: 180px;

            @include tablet {
                padding-top: 140px;
            }
            @include mobile {
                display: none;
            }
            .swiper {
                &-button {
                    &-prev,
                    &-next {
                        position: initial;
                        left: auto;
                        right: auto;
                        top: auto;
                        pointer-events: all;
                        margin: 0;
                        display: inline-flex;
                    }
                    &-next {
                        margin-left: 21px;
                    }
                }
            }
        }
    }
</style>
